import { render, staticRenderFns } from "./GamePlayLayout.vue?vue&type=template&id=1b7d9776&"
import script from "./GamePlayLayout.vue?vue&type=script&lang=js&"
export * from "./GamePlayLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports